import { UploadTypeModalComponent } from '../../../../screens/upload-type-modal/upload-type-modal.component';
import { ClaimModalComponent } from '../../claims/claim-modal/claim-modal.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { ClaimsService } from '@services/_claims/claims.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, ClaimModalComponent, UploadTypeModalComponent],
  selector: 'app-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.scss']
})
export class QuickLinksComponent implements OnInit {
  imgPath: string;
  @Input() policies: any;
  isAcmic: boolean;
  constructor(
    private acmicService: AcmicService,
    private claimsService: ClaimsService
  ) {
    this.isAcmic=acmicService.isACMIC();
  }
  reportClaim(policy) {
    this.claimsService.setClaimURL(policy);
  }
  ngOnInit(): void {
    this.imgPath = this.acmicService.isACMIC() ?
      'assets/img/images/icon-simple-arrow-right-grey.svg' :
      'assets/img/images/icon-simple-arrow-right-red.svg';
  }

}